import { Injectable } from '@angular/core';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { CommonService } from 'src/app/services/common/common.service';
import { InputAccessoriesService } from 'src/app/services/input-accessories/input-accessories.service';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Injectable({
	providedIn: 'root',
})
export class VoipHotkeyFunctionFeature {
	constructor(
		private commonService: CommonService,
		private logger: LoggerService,
		private keyboardService: InputAccessoriesService
	) {}

	public async getCapabililty(): Promise<boolean> {
		let hasCapability = false;
		this.logger.info(
			'VoipHotkeyFunctionFeature::hasCapability VOIPCapability: Before:',
			hasCapability
		);

		let response = await this.keyboardService.getVoipHotkeysSettings();

		if (response !== undefined) {
			if (response.capability) {
				this.commonService.setLocalStorageValue(
					LocalStorageKey.VOIPCapability,
					response.capability
				);
			}
			hasCapability = response.capability;
		}

		this.logger.info(
			'VoipHotkeyFunctionFeature::hasCapability VOIPCapability: After:',
			hasCapability
		);
		return hasCapability;
	}
}
